import React, { useState } from 'react';
import { Text, useWindowDimensions, View } from 'react-native';
import { CampaignSetupEmailRequest, CampaignSignupClient } from '../../api/api.g';
import useApi from '../../hooks/api-hook';
import useCampaignTranslation from '../../hooks/campaign-translation-hook';
import { useAppSelector } from '../../hooks/store-hook';
import CustomButton from '../common/CustomButton';
export default function CampaignTemporaryAccessNotice() {
  const text = useCampaignTranslation();
  const api = useApi(CampaignSignupClient);
  const email = useAppSelector(state => state.auth.user?.email?.trim() ?? '');
  const {
    width
  } = useWindowDimensions();
  const compact = width < 720;
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const resend = async () => {
    if (!email || busy) {
      return;
    }
    setBusy(true);
    setMessage('');
    try {
      const request = new CampaignSetupEmailRequest();
      request.email = email;
      await api.requestCampaignSetupEmail(request, undefined);
      setMessage(text('campaign-setup-email-sent', 'If this account needs setup, an email has been sent. Check your inbox.'));
    } catch {
      setMessage(text('campaign-signup-error', 'We could not complete this step. Try again or request an account setup email.'));
    } finally {
      setBusy(false);
    }
  };
  return <View accessibilityRole="alert" style={{
    backgroundColor: '#FFF7DE',
    borderBottomColor: '#D9A321',
    borderBottomWidth: 2,
    flexDirection: compact ? 'column' : 'row',
    alignItems: compact ? 'stretch' : 'center',
    gap: 12,
    paddingHorizontal: compact ? 16 : 24,
    paddingVertical: 12
  }}>
      <View style={{
      flex: 1
    }}>
        <Text style={{
        color: '#523900',
        fontSize: 17,
        fontWeight: '700'
      }}>
          {text('campaign-temporary-access-title', 'Your account is created!')}
        </Text>
        <Text style={{
        color: '#3D3421',
        lineHeight: 20,
        marginTop: 3
      }}>
          {text('campaign-temporary-access-description', "You're signed in temporarily for up to 24 hours. Check your email to confirm your address and create your password. You'll need it before your next sign-in or cashout.")}
        </Text>
        {!!message && <Text accessibilityLiveRegion="polite" style={{
        color: '#3D3421',
        marginTop: 5
      }}>{message}</Text>}
      </View>
      <CustomButton disabled={!email || busy} onPress={() => void resend()} title={text('campaign-resend-setup', 'Resend setup email')} style={{
      alignSelf: compact ? 'stretch' : 'center',
      minWidth: compact ? undefined : 190
    }} />
    </View>;
}
